// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '../../../../node_module_clones/react-router';

// Utils
import { getElementId } from '../../../../common/elements/utils/elementPropertyUtils';

// Styles
import './BoardListItem.scss';

const BoardListItemLoading = (props) => <div className="BoardListItemLoading" />;

const BoardListItem = ({ figure, children, className, active, linkUrl, onClick, board }) => {
    if (!board) return <BoardListItemLoading />;

    const _linkUrl = linkUrl || `/${getElementId(board)}`;

    return (
        <Link
            className={classNames('BoardListItem', className, { active })}
            to={_linkUrl}
            onClick={onClick}
            tabIndex={-1}
        >
            <div className="figure">{figure}</div>
            <div className="body">{children}</div>
        </Link>
    );
};

BoardListItem.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    figure: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    active: PropTypes.bool,
    className: PropTypes.string,

    board: PropTypes.object.isRequired,
    linkUrl: PropTypes.string,
    onClick: PropTypes.func,
};

export default BoardListItem;
